<template>
    <div class="flex flex-col min-h-screen">
        <header-web :auth="auth" :client="client" :categories="categories" :cart="cart" :balance="balance"></header-web>
        
        <main class="flex-grow">
            <slot />
        </main>

        <footer-web :account="account" />
    </div>
</template>

<script>
import HeaderWeb from "../Pages/Web/components/HeaderWeb.vue"
import FooterWeb from "../Pages/Web/components/FooterWeb.vue"

export default
{
    components: { HeaderWeb, FooterWeb },
    props: {
        auth: Object,
        account: Object,
        categories: Object,
        client: Object,
        cart: Number,
        balance: Number
    },
    name:'WebLayout'
}
</script>